import React from "react";
import "./DeleteDialog.scss";
import { Modal, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { toast } from 'react-toastify';

function DeleteDialog({
  show,
  handleClose,
  onDeleted,
  replayId
}) {

  const { t } = useTranslation();
    
    const deleteReplay = () => {
      console.log("deleting");
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: "id="+replayId
        };
        fetch(window.serverUrl+`/social/delete.php`, requestOptions)
        .then((r) => r.json())
        .then((resp) => {
            console.log("resp", resp);
            toast.success(t("replayApp.deleted"), {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: 0,
            });
            onDeleted();
        })
        .catch((err) => {
            console.error("fetch problem", err);
            toast.error(t("replayApp.deletedError"), {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: 0,
            });
        });

    }

  return (
    <Modal
      show={show}
      onHide={handleClose}
      backdrop
      keyboard={false}
      centered
      dialogClassName="delete-dialog"
    >
        <Modal.Header closeButton closeLabel={false}>
            <Modal.Title>
          {t("replayApp.deleteReplay")}
            </Modal.Title>
        </Modal.Header>
          <Modal.Body>
{t('replayApp.deleteReplayMessage')}<br/>
{t('replayApp.deleteReplayMessage2')}
        </Modal.Body>
        <Modal.Footer>
            <Button onClick={handleClose}>{t('replayApp.cancel')}</Button>
            <Button className="delete" onClick={deleteReplay}>{t('replayApp.delete')}</Button>
        </Modal.Footer>
    </Modal>
  );
}

export default DeleteDialog;
